import { useState, useEffect } from "react"
import axios from "axios"

const useFooter = () => {
  const [footerMenu, setFooterMenu] = useState([])
  const [loading, setloading] = useState(true)

  const getFooterMenu = async () => {
    const url = `${process.env.GATSBY_API_URL}/wp-json/menus/v1/menus/footer-1`

    console.log(url)

    try {
      const {
        data: { items },
      } = await axios.get(url)
      // localStorage.setItem("footerMenu", JSON.stringify(items))
      setFooterMenu(items)
      setloading(false)
    } catch (error) {
      console.log(error)
      setloading(false)
    }
  }

  useEffect(() => {
    // if (localStorage.getItem("footerMenu") !== null) {
    //   const navMenu = JSON.parse(localStorage.getItem("footerMenu"))
    //   setFooterMenu(navMenu)
    //   setloading(false)
    // } else {
    //   getFooterMenu()
    // }
    getFooterMenu()
  }, [])

  return { footerMenu, loading }
}

export default useFooter
